import netcoServer from '../../apis/netcoServer';
import {GET_SUBSCRIPTION_INFO} from "../types";
import handleResponse from '../helpers/handleResponse';
import loadingCall from "../helpers/loadingCall";

const getSubscriptionInfo= () => async (dispatch) => {
  const onSuccessPayload = data => {
    return {result:{subscriptionInfo:data.result}};
  };
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/PaymentService/getSubscriptionInfo  ', {}));
  handleResponse(dispatch, response, GET_SUBSCRIPTION_INFO, onSuccessPayload, null, [],[],[],[]);
};
export default getSubscriptionInfo;
